import settingTypes from './setting.types';
import axios from 'axios';
import Socket from 'socket.io-client';
import storage from '../../helpers/storage';

let url;
if (process.env.VUE_APP_NODE_ENV == 'production') {
  url = `https://givemagic-test.herokuapp.com`;
} else {
  url = `https://givemagic-test.herokuapp.com`;
}

const io = Socket(url);

export default {
  fetchSetting({ commit }) {
    const ls = storage.get('manager');
    commit(settingTypes.FETCH_SETTING_REQUEST);

    const options = {
      url: `${url}/settings`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${ls.token}`
      }
    };
    axios(options)
      .then(res => {
        commit(settingTypes.FETCH_SETTING_SUCCESS, {
          data: { setting: res.data.settings }
        });
      })
      .catch(error => {
        if (!error.status && !error.response) {
          return commit(settingTypes.FETCH_SETTING_FAILED, {
            error: 'Network error'
          });
        }
        if (error && error.response && error.response.status === 404) {
          return commit(settingTypes.FETCH_SETTING_FAILED, {
            error: error.response.statusText
          });
        }
        const err = error.response.data.error;
        commit(settingTypes.FETCH_SETTING_FAILED, { error: err });
      });
  },
  editSettings({ commit }, data) {
    const ls = storage.get('manager');
    commit(settingTypes.UPDATE_SETTING_REQUEST);
    const options = {
      url: `${url}/settings/update`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${ls.token}`
      },
      data: data
    };
    axios(options)
      .then(res => {
        commit(settingTypes.UPDATE_SETTING_SUCCESS, {
          data: {
            setting: res.data.settings
          }
        });
      })
      .catch(error => {
        commit(settingTypes.UPDATE_SETTING_FAILED, { error });
      });
  },
  editLogo({ commit }, data) {
    const ls = storage.get('manager');
    commit(settingTypes.UPDATE_SETTING_REQUEST);
    let formData = new FormData();
    formData.append('logo', data.logo);
    const config = {
      headers: {
        'content-type': 'multipart/form-data',
        Authorization: `Bearer ${ls.token}`
      }
    };
    axios
      .post(`${url}/settings/update`, formData, config)
      .then(res => {
        commit(settingTypes.UPDATE_SETTING_SUCCESS, {
          data: res.data
        });
      })
      .catch(error => {
        commit(settingTypes.UPDATE_SETTING_FAILED, { error });
      });
  },

  AddEmployees({ commit }, employeeData) {
    const ls = storage.get('manager');
    commit(settingTypes.ADD_EMPLOYEE_REQUEST);

    const options = {
      url: `${url}/workspace/add-admin`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${ls.token}`
      },
      data: {
        first_name: employeeData.first_name,
        last_name: employeeData.last_name,
        email: employeeData.email,
        phone_number: employeeData.phone_number,
        isAdmin: employeeData.type
      }
    };

    axios(options)
      .then(success => {
        commit(settingTypes.ADD_EMPLOYEE_SUCCESS, {
          data: success.data.employee
        });
      })
      .catch(error => {
        commit(settingTypes.ADD_EMPLOYEE_FAILED, { error });
      });
  }
  // deleteTodosRequest({ commit }, data) {
  //   const ls = storage.get('manager');
  //   commit(todosTypes.DELETE_TODOS_REQUEST);

  //   const options = {
  //     url: `${url}/todos/delete/${data._id}`,
  //     method: 'DELETE',
  //     headers: {
  //       'Content-Type': 'application/json',
  //       Authorization: `Bearer ${ls.token}`
  //     }
  //   };
  //   axios(options)
  //     .then(res => {
  //       commit(todosTypes.DELETE_TODOS_SUCCESS, {
  //         deleted: { todo: res.data.cta }
  //       });
  //     })
  //     .catch(error => {
  //       // commit(todosTypes.DELETE_TODOS_FAILED, { error });
  //     });
  // },
};
